import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import useUser from '@hooks/auth/useUser';
import usePrepaidCardFetchEnabled from '@hooks/prepaidCard/usePrepaidCardFetchEnabled';
import { useQuery } from '@tanstack/react-query';

function useFavoritePrepaidCards() {
    const { user } = useUser();
    const fetchEnabled = usePrepaidCardFetchEnabled();
    const { data, status } = useQuery({
        ...userPrepaidCardQueries.list(),
        enabled: !!user && fetchEnabled,
        retry: false,
        // 매머드와 동일하게 재진입·명시적 새로고침에서 목록을 조회한다.
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
    });
    const prepaidCards = data?.cards;
    const isLoading = status === 'pending';
    const isBlank = !isLoading && (!prepaidCards || prepaidCards.length === 0);
    return {
        prepaidCards, isBlank, isLoading,
    };
}

export default useFavoritePrepaidCards;
